import React from "react";
import { useLocation } from "react-router-dom";

const Header = ({ toggleSidebar }) => {
	const location = useLocation();

	// Convert path to breadcrumb-friendly format
	const getBreadcrumb = () => {
		let paths = location.pathname.split("/").filter(Boolean);

		// Hide last segment if it looks like an ID (UUID, numbers, mixed hash)
		if (
			paths.length > 1 &&
			/^[0-9a-fA-F-]{8,}$/.test(paths[paths.length - 1])
		) {
			paths = paths.slice(0, -1);
		}

		if (paths.length === 1 && paths[0].toLowerCase() === "dashboard") {
			return "Welcome to O4S HR Setu";
		}

		const formatted = paths.map((segment) =>
			segment.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
		);

		return formatted.join(" / ");
	};

	return (
		<header className="header px-3 py-3 d-flex justify-content-between align-items-center bg-white">
			{/* Mobile Header */}
			<div className="d-md-none w-100 d-flex justify-content-between align-items-center">
				<button
					className="btn btn-sm btn-outline-primary"
					onClick={toggleSidebar}
				>
					<i className="bi bi-list fs-4"></i>
				</button>
				<h5 className="mb-0 fw-bold text-primary text-center flex-grow-1">
					O4S HR Setu
				</h5>
			</div>

			{/* Desktop Header */}
			<h5 className="mb-0 fw-bold text-primary d-none d-md-block">
				{getBreadcrumb()}
			</h5>
		</header>
	);
};

export default Header;
